import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { useLang } from "../../context/langProvider";

const langList = [
    { code: "fr", name: "Français", flag: "https://flagcdn.com/w40/fr.png" },
    { code: "de", name: "Deutsch", flag: "https://flagcdn.com/w40/de.png" },
    { code: "it", name: "Italiano", flag: "https://flagcdn.com/w40/it.png" },
    { code: "es", name: "Español", flag: "https://flagcdn.com/w40/es.png" },
    { code: "en", name: "English", flag: "https://flagcdn.com/w40/gb.png" },
    { code: "nl", name: "Nederlands", flag: "https://flagcdn.com/w40/nl.png" },
    { code: "pl", name: "Polski", flag: "https://flagcdn.com/w40/pl.png" },
    { code: "ro", name: "Română", flag: "https://flagcdn.com/w40/ro.png" },
    { code: "pt", name: "Português", flag: "https://flagcdn.com/w40/pt.png" },
    { code: "cs", name: "Čeština ", flag: "https://flagcdn.com/w40/cz.png" }

];

const LangSelect = () => {
  const { lang, setLang } = useLang(); // ← contexte
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = langList.find((l) => l.code === lang);

  const handleSelect = (country) => {
    setLang(country.code);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="lang-select" ref={dropdownRef}>
      <div className="lang-selected" onClick={() => setOpen(!open)}>
        <img src={selected.flag} alt={selected.code} />
        <span>{selected.code.toUpperCase()} </span>
       
      </div>
      {open && (
        <ul className="lang-dropdown">
          {langList.map((country) => (
            <li key={country.code} onClick={() => handleSelect(country)}>
              <img src={country.flag} alt={country.code} />
              <span>{country.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LangSelect;
